<template>
    <v-app-bar class="toolbar app-header" dense height="126px" padding="0" flat
               style="max-width: 100%; margin: 0 auto;" color="transparent">
        <router-link to="/">
            <img :src="require('@/assets/logo.svg')" alt width="150"
                 class="logo-kiey-chat"/>
        </router-link>
      <v-spacer></v-spacer>
      <v-btn
              v-if="!user"
              class="font-weight-black login-btn t-b-theme f-16 login_button"
              depressed
              height="100px"
              v-on:click="$router.push('/login')"
      >Login</v-btn>
      <v-toolbar-items
          class="hidden-sm-and-down menus-right"
          v-if="!user"
      >
        <v-btn
            v-if="!user"
            class="font-weight-black login-btn t-b-theme f-16"
            depressed
            height="100px"
            v-on:click="$router.push('/login')"
        >Login</v-btn>
      </v-toolbar-items>
      <v-toolbar-items
          class="hidden-sm-and-down menus-right"
          style="height: 45px;"
          v-if="user"
      >
        <v-menu v-if="user" left bottom style="z-index: 10;">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <div class="header-profile-pic">
                <UserAvatar :item="user" :size="'36'" style="top: -6px;" />
                <p>
                  <span>{{ user.first_name }}</span>
                  <span>{{ user.last_name }}</span>
                </p>

              </div>
            </v-btn>
          </template>

          <v-list class="menu-logged">
            <v-list-item
                v-for="(item, index) in profile_items"
                :key="index"
                @click="onClickProfileMenu(item)"
                class="menu-logged-options"
            >
              <v-list-item-title class="menu-option">{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
</template>

<script>
  import UserAvatar from "@/components/UserAvatar";
  import {firestore} from "@/config/firebase";
  import {mapState} from "vuex";

  export default {
      name: "SiteHeaderLanding",
      components: {
        UserAvatar
      },
      computed: {
        ...mapState({
          user: state => state.Authenticate.user
        })
      },
      watch: {
        user(val) {
          if (val) {
            this.unsubscribe();
            this.init();
          } else {
            this.unsubscribe();
          }
        },
      },
      data: () => ({
        suscriptions: [],
        profile_items: [
          {
            title: "Admin panel",
            route: "/login",
            icon: ""
          },
          {
            title: "Logout",
            route: "/login",
            icon: ""
          }
        ]
      }),
      created() {
        this.init();
      },
      methods: {
        init() {
          const self = this;
          if (self.user) {
            self.suscriptions.push(firestore.collection("users").doc(self.user.owner_id)
              .onSnapshot(doc => {
                if (doc.exists) {
                  const user = doc.data();
                  self.$store.commit("Authenticate/updateUser", user);
                  self.$store.commit("Display_information/updateLogged", user);
                }
              }, error => {
                console.error('[SiteHeaderLanding] User doc listener error:', error);
              }));
          }
        },
        unsubscribe() {
          for (const suscription of this.suscriptions) {
            suscription ? suscription() : '';
          }
        },
        onClickProfileMenu(item) {
          try {
            switch (item.title) {
              case "Logout": {
                this.$store.dispatch("Authenticate/logout");
                this.$store.dispatch("Banner/hide");
                this.$router.push(item.route);
                break;
              }
              case "Admin panel": {
                this.$router.push(item.route);
                break;
              }
              default: {
                this.$router.push("/login");
                break;
              }
            }
          } catch (error) {
            //
          }

        }
      }
    };
</script>

<style lang="scss">
  @import 'src/assets/css/landing';
</style>
